module.exports = __webpack_public_path__ + "static/media/Logo.713567c7.svg";